import Router from 'vue-router';
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import RegResult from './views/RegResult.vue'
import NotFound from './views/404.vue';
import ForgetPwd from './views/ForgetPWD.vue';
import OAuthCallback from './views/OAuthCallback.vue';
import Home from './views/Home.vue';
//import Main from './views/Main.vue'
import Trend from './views/nav1/Trend.vue';
import Table from './views/nav1/Table.vue';
import Info from './views/nav1/Info.vue';
import Edit from './views/nav1/Edit.vue';
import Department from './views/nav1/Department.vue';
import Category from './views/nav1/Category.vue';
import Course from './views/nav1/Course.vue';
import Favorite from './views/nav1/Favorite.vue';
import Profile from './views/nav1/Profile.vue';
import Report from './views/nav1/Report.vue';
import Setting from './views/nav1/Setting.vue';
import PDF from './views/nav1/PDF.vue';
import Video from './views/nav1/Video.vue';
import AccountTable from './views/nav1/AccountTable.vue';
import RegApproval from './views/nav1/RegApproval.vue';
import EditAccount from './views/nav1/EditAccount.vue';
//import Form from './views/nav1/Form.vue'

var routes = [
    {
        path: '/login',
        component: Login,
        name: 'login',
        hidden: true
    },
    {
        path: '/register',
        component: Register,
        name: 'register',
        hidden: true
    },
    {
        path: '/regResult',
        component: RegResult,
        name: 'regResult',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/forgetPwd',
        component: ForgetPwd,
        name: 'forgetPWD',
        hidden: true
    },
    {
        path: '/forgetPwd/:id',
        component: ForgetPwd,
        name: 'forgetPWD',
        hidden: true
    },
    {
        path: '/oauthCallback',
        component: OAuthCallback,
        name: 'oauthCallback',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: 'home',
        children: [
            {   path: 'trend', 
                component: Trend, 
                name: 'trend', 
                hidden: true
            },
            {   path: 'table', 
                component: Table, 
                name: 'table', 
                hidden: true
            },
            {   path: 'table/:id', 
                component: Table, 
                name: 'table', 
                hidden: true
            },
            {   path: 'info', 
                component: Info, 
                name: 'info', 
                hidden: true
            },
            {   path: 'info/:id', 
                component: Info, 
                name: 'info', 
                hidden: true
            },
            {   path: '/edit', 
                component: Edit, 
                name: 'edit', 
                hidden: true
            },
            {   path: '/edit/:id',
                component: Edit, 
                name: 'edit', 
                hidden: true
            },
            {   path: '/editAccount', 
                component: EditAccount, 
                name: 'editAccount', 
                hidden: true
            },
            {   path: '/editAccount/:id',
                component: EditAccount, 
                name: 'editAccount', 
                hidden: true
            },
            {   path: '/department', 
                component: Department, 
                name: 'department', 
                hidden: true
            },
            {   path: '/category', 
                component: Category, 
                name: 'category', 
                hidden: true
            },
            {   path: '/course', 
                component: Course, 
                name: 'course', 
                hidden: true
            },
            {   path: '/favorite', 
                component: Favorite, 
                name: 'favorite', 
                hidden: true
            },
            {   path: '/report', 
                component: Report, 
                name: 'report', 
                hidden: true
            },
            /*
            {   path: '/account', 
                component: AccountTable, 
                name: 'account', 
                hidden: true
            },
            */
            {   path: '/account/:id', 
                component: AccountTable, 
                name: 'account', 
                hidden: true
            },
            {   path: '/regApproval', 
                component: RegApproval, 
                name: 'regApproval', 
                hidden: true
            },
            {   path: '/profile', 
                component: Profile, 
                name: 'profile', 
                hidden: true
            },
            {   path: '/profile/:id',
                component: Profile, 
                name: 'profile', 
                hidden: true
            },
            {   path: '/setting',
                component: Setting, 
                name: 'setting', 
                hidden: true
            },
            {   path: '/pdfView/:id', 
                component: PDF, 
                name: 'pdf', 
                hidden: true
            },
            {   path: '/videoView/:id', 
                component: Video, 
                name: 'video', 
                hidden: true
            },
        ]
    }, 
];
export default routes;


// WEBPACK FOOTER //
// ./src/routes.js